import { ErrorHandler, inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { StandardLogService } from "src/standard/logging/logging";

export const uncaughtError$ = new BehaviorSubject<Error | undefined>(undefined);

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  readonly #logger = inject(StandardLogService);

  handleError(error: Error) {
    // Check if the error has a custom 'isHandled' property
    // eslint-disable-next-line
    if ((error as any).isHandled) {
      // Error is already handled, do not show the alert again
      return;
    }

    // Log the error
    this.#logger.logException(error);

    // Add a custom property to the error indicating it has been handled
    // eslint-disable-next-line
    (error as any).isHandled = true;

    // Emit the error to the uncaughtError$ observable
    uncaughtError$.next(error);

    // IMPORTANT: Rethrow the error otherwise it gets swallowed
    throw error;
  }
}
